// extracted by mini-css-extract-plugin
export default {"root":"ExpertCard_root__ObUSf","status":"ExpertCard_status__8ykId","expertInfo":"ExpertCard_expertInfo__lnxj+"};